
    import {Component, Prop, Vue, Emit, Watch} from 'vue-property-decorator';
    @Component
    export default class SearchTitle extends Vue {
      private title: string = ''
      @Emit('getTitle')
       sendTitle(title:string){}
    }
